import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import ButtonHtmlRenderer from './Renderer/ButtonHtmlRenderer';
const ButtonControls = lazyLoad(() => import('./Controls/ButtonControls'));
export default (settings) => {
    const buttonPlugin = createPlugin(Object.assign({ Renderer: ButtonHtmlRenderer, Controls: ButtonControls }, settings));
    return buttonPlugin;
};
//# sourceMappingURL=index.js.map